import notifier from './notifier';

export default {
	mixins: [notifier],
	data() {
		return {
			activeAlert: false,
			popupActive: false,
			theme: '',
			text: '',
			images: '',
			deletedId: 0,
			files: [],
			terminatingPopupActive: false,
		}
	},
	methods: {
		async upload(upload) {
			this.files = this.$refs.file.files;
			let formData = new FormData();
			formData.append('files', this.files);
			let res = await this.$http.post('/upload/many', formData)
		},
		openAlert(color, id, successCallback = null) {
			this.deletedId = id;
			this.terminatingPopupActive = true;
		},
		async closeSupport(){
			try {
				await this.$http.post('/support/close/'+this.deletedId);
				this.terminatingPopupActive = false;
				this.notifySuccess(this.$t('dataIsSaved'));

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		betweenDate(date) {
			function num_word(value, words) {
				value = Math.abs(value) % 100;
				var num = value % 10;
				if (value > 10 && value < 20) return words[2];
				if (num > 1 && num < 5) return words[1];
				if (num == 1) return words[0];
				return words[2];
			}

			let difference = (Date.parse(new Date()) - Date.parse(date)) / (1000 * 60 * 60 * 24 * 30)
			if (difference > 1) {
				return this.$t('more') + ' ' + Math.floor(difference) + " " + num_word(Math.floor(difference),
					[this.$t('month(1)'), this.$t('month(2-5)'), this.$t('month(6-0)')]) + ' ' + this.$t('month(6-0)');
			} else {
				return this.$t('lessThanMonth');
			}
		}
	}
}
